import { ShortClientResponse } from '@/modules/clients/types/dto/client-short.dto';
import { PaymentTermsResponse } from '@/modules/clients/types/dto/payment-terms.dto';
import { OpsiumUserShortResponse } from '@/modules/common/types/dto/response/opsium-user-response';

import { InvoiceEntityTypeResponse } from '../invoice-entity-type.dto';
import { InvoiceStatusResponse } from '../invoice-status.dto';
import { InvoiceSyncOperationResponse } from '../invoice-sync-operation.dto';
import { InvoiceProjectResponse } from './invoice-project.response';
import { InvoiceSyncErrorResponse } from './invoice-sync-error.response';

export enum InvoiceSyncStatusResponse {
  SCHEDULED = 'SCHEDULED',
  IN_PROGRESS = 'IN_PROGRESS',
  SYNCHRONIZED = 'SYNCHRONIZED',
  FAILED = 'FAILED',
}

export enum InvoiceAllowedActionResponse {
  EDIT = 'EDIT',
  DELETE = 'DELETE',
  RETRY = 'RETRY',
}

export interface InvoiceDetailsItemResponse {
  entityType: InvoiceEntityTypeResponse;
  entityId: number | null;
  description: string | null;
  quantity: string | null;
  unitPrice: string | null;
  amount: string;
  member: OpsiumUserShortResponse | null;
}

/** Invoice details returned by GET /api/invoices/:invoiceId. */
export interface InvoiceDetailsResponse {
  id: number;
  externalId: string | null;
  referenceNumber: string | null;
  status: InvoiceStatusResponse;
  syncStatus: InvoiceSyncStatusResponse;
  syncOperation: InvoiceSyncOperationResponse | null;
  syncError: InvoiceSyncErrorResponse | null;
  syncToken: string;
  allowedActions: InvoiceAllowedActionResponse[];
  project: InvoiceProjectResponse | null;
  client: ShortClientResponse;
  startDate: string | null;
  endDate: string | null;
  issuedDate: string;
  dueDate: string;
  paymentTerm: PaymentTermsResponse | null;
  currencyCode: string;
  totalAmount: string;
  balance: string;
  amountPaid: string;
  paymentDetailsId: number | null;
  paymentMemo: string | null;
  items: InvoiceDetailsItemResponse[];
}
